import { render } from "./DownloadCard.vue?vue&type=template&id=09ae6659"
import script from "./DownloadCard.vue?vue&type=script&lang=js"
export * from "./DownloadCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/derolfgroep-ict/derolfgroep-ict/web/app/themes/rolfhardware/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__